import type { SyntheticEvent } from "react"
import { IconXmarkOutline18 as XIcon } from "nucleo-ui-outline-18"

import { IconButton, Tooltip } from "@productlane/ui"

import { useRemoveRedirect } from "./use-remove-redirect"

// Same as the slug field above it: keystrokes and clicks stay out of the
// surrounding Radix menu.
const stop = (event: SyntheticEvent) => event.stopPropagation()

// Rows share the slug field's inset and type, so each old path reads as an
// earlier value of that field. Long paths wrap: the article segment is the end.
export const ArticleOldUrls = ({
	articleId,
	urlNames,
	canEdit,
}: {
	articleId: string
	urlNames: readonly string[]
	canEdit: boolean
}) => {
	const removeRedirect = useRemoveRedirect()

	return (
		<div
			role="presentation"
			className="px-2 pb-1"
			onKeyDown={stop}
			onPointerDown={stop}
			onClick={stop}
		>
			<p className="px-3 pb-0.5 pt-1 text-xs leading-4 text-tertiary">
				Also opens from
			</p>
			<ul className="max-h-40 list-none overflow-y-auto pb-0.5">
				{urlNames.map((urlName) => (
					<li
						key={urlName}
						data-testid="article-old-url"
						className="group/row flex items-start gap-1 rounded-md py-0.5 pl-3 pr-1 hover:bg-gray-100 dark:hover:bg-gray-800"
					>
						<span className="min-w-0 flex-1 py-0.5 font-mono text-xs leading-4 [overflow-wrap:anywhere]">
							<span className="text-tertiary">/docs/</span>
							<span className="text-secondary">{urlName}</span>
						</span>
						{canEdit && (
							<Tooltip label="Remove redirect">
								<IconButton
									Icon={XIcon}
									variant="ghost"
									size="sm"
									iconClassName="h-3 w-3"
									aria-label="Remove redirect"
									className="flex-none cursor-default opacity-0 focus-visible:opacity-100 group-hover/row:opacity-100"
									onClick={() => void removeRedirect(articleId, urlName)}
								/>
							</Tooltip>
						)}
					</li>
				))}
			</ul>
		</div>
	)
}
